import { gql } from '@apollo/client'
import { BusinessMenuList } from './header';

export const Contact = gql`
fragment Contact on ContactInfo {
    internalName
    heading
    subHeading
    content{
      type
      value
    }
}
`;

export const ResourceSet = gql `
fragment ResourceSet on BusinessResourceSet {
  internalName
  formTitle
  formSubTitle
  resources{
    key
    value
    required
  } 
}
`

export const CardImage = gql`
fragment CardImage on BusinessCardImage {
  file{
    url
    fileName
    contentType
  }
  title
  description
}
`
export const ComposePage = gql `
fragment ComposePage on BusinessComposePage {
  internalName
    slug
    pageTitle
    content{
        sitemap{
        ...BusinessMenuList
        }
      businessContent{
        contentType
          bannerImage
          bannerTitle
          bannerPhoneNumber
          exploreScrollContent
          exploreScrollHeading
          headingPosition
          exploreLinkText
          exploreLinkUrl
          isProductBanner
          backgroundVideoId
          bannerSubTitle
          primaryLinkText
          primaryLinkUrl
          secondaryLinkText
          secondaryLinkVideoId
          heading
          content
          iframeUrl
          isAccordion
          accordionTitle
  formTitle
  formSubTitle
  resources{
    key
    value
    required
  }
          componentSectionTitle 
          sectionSubTitle
          description         
          displayTile
          isProductSection
          isCarousel
          isRelatedContentSection
          contentType
          components{
            internalName
            isSlider
            imageType
            contentType
            cards {
              imageUrl
              description
              linkText
              linkUrl
              title
              gradientColor
              internalName
            }
            imageUrl{
              ...CardImage
            }
            imagePosition
            backgroundGradientColor
            linkText
            imageLinkDocument{
              ...CardImage
            }
            imageLinkUrl
            cardTitle
            cardDescription
            brightcoveVideoId
            autoplay
            links {
              linkText
              linkUrl
              linkDocument {
                ...CardImage
              }
            }
              images{
              ...CardImage
            }
              logoImage{
              ...CardImage
              }
              footNoteText
              contentOverImage
          }
      }
    }
    requestACallBackFormRequired
    contactUsSectionRequired
}
${CardImage}
${BusinessMenuList}
`
